import styled from 'styled-components';
import { borderRadius, smallShadow, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p1100: pxToRem(1100),
};

export const TableWrapper = styled.div`
  ${smallShadow};
  min-width: ${customSpacing.p1100};
  border-radius: ${borderRadius.xl};
`;

export const EmptyStateWrapper = styled.div`
  padding: ${spacing.x5};
  `;
